import React from "react";
import { List, AutoSizer, ListRowProps } from "react-virtualized";

const ROW_HEIGHT = 60;
const OVERSCAN_ROWS = 6;
const MAX_VISIBLE_ROWS = 6;
const LISTBOX_PADDING = 0;

export const VirtualizedListbox = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLElement>
>(function VirtualizedListbox(props, ref) {
  const { children, ...other } = props;

  const items = React.Children.toArray(children) as React.ReactElement<
    React.HTMLAttributes<HTMLLIElement>
  >[];

  const rowCount = items.length;
  const height =
    Math.min(rowCount, MAX_VISIBLE_ROWS) * ROW_HEIGHT + LISTBOX_PADDING * 2;

  const rowRenderer = ({ index, key, style }: ListRowProps) => {
    const item = items[index];

    return React.cloneElement(item, {
      key,
      style: {
        ...style,
        ...(item.props.style || {}),
      },
      role: "option",
      "aria-selected":
        (item.props as any)["aria-selected"] ?? (item.props as any).selected ?? false,
    });
  };

  return (
    <div ref={ref} {...other} role="listbox" aria-label="autocomplete-listbox">
      <AutoSizer disableHeight>
        {({ width }) => (
          <List
            width={Math.max(0, width)}
            height={height}
            rowCount={rowCount}
            rowHeight={ROW_HEIGHT}
            rowRenderer={rowRenderer}
            overscanRowCount={OVERSCAN_ROWS}
          />
        )}
      </AutoSizer>
    </div>
  );
});